import React from "react";

// @mui-component
import type { TableCellProps } from "@mui/material/TableCell";
import XTableCell from "@mui/material/TableCell";

const TableCell: React.FC<TableCellProps> = (props) => {
  return <XTableCell {...props}>{props.children}</XTableCell>
};

export default TableCell;
